import { render, staticRenderFns } from "./virtual-scroller-slot-wrapper.vue?vue&type=template&id=6e34cd34&"
import script from "./virtual-scroller-slot-wrapper.vue?vue&type=script&lang=js&"
export * from "./virtual-scroller-slot-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports